import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, Grid, Form, Button } from 'semantic-ui-react';
import { cancelInventoryDonation, updateDonationQuantity, updateDonationUser, saveDonation } from '../../actions/inventoryActions';

class DonateModal extends React.Component {

    constructor(props){
        super(props);
        this.sendDonation = this.sendDonation.bind(this);
        this.finishDonation = this.finishDonation.bind(this);
        this.state = {
            working: false,
            sent : false,
            error : ''
        }

    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    async sendDonation(){

        console.log('oorg')
        this.setState({working:true})
        try{
            await this.props.saveDonation(this.props.donation);
            this.setState({working:false, sent : true, error : ''})

        }
        catch(e){
            console.error(e);
            this.setState({working : false})
        }
    }

    async finishDonation(){
        this.setState({
            working: false,
            sent : false,
            error : ''
        });
        this.props.cancelInventoryDonation();
    }

   
    render(){

        let {item, donation} = this.props;
        if(!item) return null;
        if(!donation) return null;

        const renderForm = ()=>{
            if(this.state.sent){
                    return (
                        <div>
                            <h3 className="f2 m-0 c-primary bold">Thankyou. Your pledge has been received. </h3>
                            <p>We have sent an email to you with details on where to take/post the item. </p>
                            <p className="f3 mt-1 c-primary bold">Pledge Ref: {donation.ref}</p>
                        </div>
                    )
            } else {
                return(
                    <Form>
                            <Form.Input 
                            value={this.props.donation.quantity}
                            onChange={(e,d)=>{this.props.updateDonationQuantity(d.value)}}
                            type="number" label="Quantity you would like to donate" 
                            />
                            <Form.Input 
                                value={this.props.donation.givrEmail}
                                onChange={(e,d)=>{this.props.updateDonationUser('email', d.value)}}
                            type="email" label="Your email address" />
                            <Form.Group widths='equal'>
                            <Form.Input
                                value={this.props.donation.givrFirstName}
                                onChange={(e,d)=>{this.props.updateDonationUser('firstName', d.value)}}
                            fluid label='First name' placeholder='First name' />
                            <Form.Input
                                    value={this.props.donation.givrLastName}
                                    onChange={(e,d)=>{this.props.updateDonationUser('lastName', d.value)}}                           
                                    fluid label='Last name' placeholder='Last name' />
                            </Form.Group>
                        </Form>
                )
            }
            
        }

        const renderActions = ()=>{
            if(this.state.sent){
                return (
                    <Modal.Actions>
                        <Button onClick={this.finishDonation} loading={this.state.working} primary size="huge" content="Done" />
                    </Modal.Actions>
                )
            } else {
                return (
                    <Modal.Actions>
                        <Button onClick={this.props.cancelInventoryDonation} inverted floated="left" color="red" content="Cancel" />
                        <Button onClick={this.sendDonation} loading={this.state.working} primary size="huge" content="Pledge this item" />
                    </Modal.Actions>
                )
            }
        }
        return (
            <div className="DonateModal">
                <Modal
                 className="DonateModal"
                    open={(donation)}
                    closeOnDimmerClick={true}
                >
                    
                    <Modal.Content>
                        
                        
                        
                        <Grid stackable>
                        <Grid.Row>
                            <Grid.Column>
                            <div className="DonateModal-logo" style={{backgroundImage : `url(${item.logo})` }} />
                            <h3 className="f3 m-0 c-primary bold">{item.name}</h3>  
                            </Grid.Column>
                              
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={(item.image) ? 12 : 16}>
                            <p className="f5 mb-2">{item.description}</p>

                            {renderForm()}

                            </Grid.Column>
                            <Grid.Column  width={(item.image) ? 4 : 0}>
                                <img src={item.image} alt=""/>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>

                    </Modal.Content>
                    {renderActions()}
                  
                </Modal>
            </div>
        )
    }
}

DonateModal.propTypes = {
    
}

const mapStateProps = (state) => {
    return {
        item : state.inventory.selectedRef,
        donation : state.inventory.donation
    };
}

export default  connect(mapStateProps, {  cancelInventoryDonation, updateDonationQuantity, updateDonationUser, saveDonation})(DonateModal);



// WEBPACK FOOTER //
// ./src/components/common/DonateModal.js